module.exports = __webpack_public_path__ + "static/media/_martinique.4de172f5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_martinique.svg
// module id = 2337
// module chunks = 7